import style from './style.module.scss'
import { Dispatch, SetStateAction, ComponentPropsWithoutRef } from 'react'
import classNames from 'classnames'
import Header from 'components/Admin/Shared/Container/Header'

type Props = ComponentPropsWithoutRef<'div'> & {
  header?: string
  headerButtonText?: string
  headerButtonLink?: string
  headerIcon?: 'lock'
  headerToggle?: boolean
  headerToggleValue?: boolean
  headerToggleText?: string
  headerToggleCallback?: Dispatch<SetStateAction<boolean>>
  subHeader?: string
  subHeaderComponent?: any
  offsetBackground?: boolean
}

function Container(props: Props) {
  const {
    header,
    headerIcon,
    subHeader,
    offsetBackground,
    children,
    subHeaderComponent,
  } = props

  return (
    <div
      className={classNames(style.wrapper, {
        [style.offsetBackground]: offsetBackground,
      })}
    >
      <Header
        header={header}
        headerTypographyType='body'
        icon={headerIcon}
        subHeader={subHeader}
        subHeaderComponent={subHeaderComponent}
      />
      <div className={style.rowGroup}>{children}</div>
    </div>
  )
}

export default Container
